<template>
  <!-- 发布已付款记录 -->
  <zl-dialog class="zl-saas" title="发布已付款记录" ref="dialog" width="1000px" :close-on-click-modal="false">
    <el-form label-width="140px" :model="form" :rules="rules" ref="form">
      <el-form-item label="付款单号:" prop="orderPayCode">
        <span>{{form.orderPayCode}}</span>
      </el-form-item>
      <el-form-item label="申请付款金额(元):" prop="applyMoney">
        <span class="money-color__orange">{{_util.formatMoney(form.applyMoney)}}</span><span>{{currencyCH}}</span>
      </el-form-item>
      <el-form-item label="备注:" prop="applyRemark">
        <span>{{form.applyRemark}}</span>
      </el-form-item>
      <el-form-item label="付款方式:" prop="payWay">
        <el-radio-group v-model="form.payWay">
          <el-radio
            v-for="(value, id) in enums.payType"
            :key="id"
            :label="id">{{value}}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="实际付款金额(元):" prop="realMoney">
        <el-input v-model="form.realMoney" style="width:380px" ></el-input>
        <span style="margin-left: 15px">{{currencyCH}}</span>
      </el-form-item>
      <el-form-item label="付款说明:" prop="payRemark">
        <el-input v-model="form.payRemark" style="width:380px" type="textarea" rows="3" maxlength="200" placeholder="可输入200字"></el-input>
      </el-form-item>
      <el-form-item label="已支付的证明附件:" prop="fileId">
        <zs-upload drag :multiple="false" v-model="form.fileId">
        </zs-upload>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button size="small" type="primary" @click="confirm">向供应商发布已付款记录</el-button>
    </template>
  </zl-dialog>
</template>
<script>
import store from '@/store'
import zsUpload from '@/components/zsUpload'
import { enums } from '@/lib/enum'
export default {
  components: {
    zsUpload
  },
  data() {
    return {
      enums,
      form: {
        orderId: '',
        id: '',
        orderPayCode: '', // 付款单号
        applyMoney: '', // 申请付款金额
        applyRemark: '', // 备注
        payWay: '', // 付款方式
        realMoney: '', // 实际付款金额
        payRemark: '', // 付款说明
        fileId: '' // 附件ID
      },
      rules: {
        payWay: [{ required: true, message: '付款方式不能为空' }],
        realMoney: [
          { required: true, message: '实际付款金额不能为空' },
          {
            pattern: /^[0-9.]*$/,
            message: '必须为大于等于0的数字',
            trigger: 'blur'
          },
          {
            pattern: /^[0-9]+[.]?[0-9]{0,6}$/,
            message: `输入最多6位小数`,
            trigger: 'blur'
          }
        ],
        fileId: [{ required: true, message: '请上传已支付的证明附件' }]
      },
      currencyCH: '人民币'
    }
  },
  methods: {
    open(args) {
      this.form.id = args.id
      this.form.orderId = args.orderId
      this.form.orderPayCode = args.orderPayCode
      this.form.applyMoney = args.applyMoney
      this.form.applyRemark = args.applyRemark
      if (args.currencyCH) {
        this.currencyCH = args.currencyCH
      }
      return this.$refs.dialog.open()
    },
    cancel() {
      this.$refs.dialog.cancel()
    },
    confirm() {
      console.log()
      this.$refs.form.validate(valid => {
        if (valid) {
          store.dispatch('releasePaymentOrder', this.form).then(res => {
            this.$zl.message.success('发布付款成功')
            this.$refs.dialog.close()
          })
        }
      })
    }
  }
}
</script>
